import {useEffect, useState} from 'react';
import {InButton} from '../../../../../../common-lib/src/components';
import {TextArea} from '../../../../../../common-lib/src/components/TextArea/TextArea';
import {CommonDialog} from '../CommonDialog/CommonDialog';
import styles from './AddBotMemories.module.css';
import {api} from '../../../../../../common-lib/src/api/Api';
import {enqueueSnackbar} from 'notistack';

type Props = {
	onClose: (withSave: boolean) => void;
	botId: number;
};

export const AddBotMemories = ({onClose, botId}: Props) => {
	const [value, setValue] = useState('');
	const [isLoading, setIsLoading] = useState(false);
	const [error, setError] = useState(false);
	const handleSubmitClick = () => {
		setIsLoading(true);
		api
			.createMemoryItem(botId, value)
			.then(() => {
				setIsLoading(false);
				onClose(true);
			})
			.catch((error) => {
				setIsLoading(false);
				setError(true);
				enqueueSnackbar(error.message, {variant: 'error'});
			})
			.finally(() => {
				setIsLoading(false);
			});
	};

	useEffect(() => {
		if (value.length > 1000) {
			setError(true);
		} else {
			setError(false);
		}
	}, [value]);

	return (
		<CommonDialog title="Add bot's memory" onClose={() => onClose(false)}>
			<div className={styles.content}>
				<TextArea
					maxLength={1000}
					placeholder="Enter details or key information you'd like the bot to remember here..."
					className={styles.textArea}
					onChange={(v) => setValue(v)}
					value={value}
					disabled={isLoading}
				/>
				<InButton
					id="add-bot-memory"
					isDisabled={!value.trim() || error}
					onClick={handleSubmitClick}
					loading={isLoading}
					className={styles.btn}
				>
					{isLoading ? <>Loading</> : <>Add</>}
				</InButton>
			</div>
		</CommonDialog>
	);
};
